import React from 'react';

/**
 * Internal DS overlay portal owner. Modal-hosted overlays use the current modal
 * dialog as their portal container so Escape/focus handling stays scoped.
 */
export const FmOverlayPortalContext = React.createContext<React.RefObject<HTMLElement | null> | null>(null);
